import * as React from 'react';

export interface IPhbMenuLink {
    text: string;
    href: string;
}

/**
 * Shared between header.view.tsx (provider) and navigation-menu.view.tsx (consumer).
 * Put this file next to category-product-count.ts (src/.../utils) so both views can import
 * '../../utils/phb-mobile-menu-context'.
 */
export interface IPhbMobileMenuContext {
    /** First screen of the drawer: Home, Products (opens the categories), Contact us */
    homeLink?: IPhbMenuLink;
    contactLink?: IPhbMenuLink;
    productsText: string;
    /** Target of the "View all" link shown under the categories */
    productsHref?: string;
    /** True while the drawer is open. The menu goes back to the first screen when it closes. */
    isMenuOpen: boolean;
    /** The menu asks the header to show (or hide, with undefined) a Back arrow in the drawer's top bar */
    setBackHandler: (handler: (() => void) | undefined) => void;
}

export const PhbMobileMenuContext = React.createContext<IPhbMobileMenuContext | undefined>(undefined);
